import { Media } from '@kiwicom/account-global-contexts';
import { Skeleton } from '@kiwicom/orbit-components';
import { useIntl } from 'react-intl';

const ReferFriendPlaceholder = (): JSX.Element => {
  const intl = useIntl();

  return (
    <>
      <Media greaterThanOrEqual="tablet">
        <Skeleton
          width="100%"
          height={700}
          dataTest="ReferFriendPlaceholder-Desktop"
          title={intl.formatMessage({
            id: 'common.loading',
            defaultMessage: 'Loading',
          })}
        >
          <rect x="0" y="0" height="325" width="100%" />
          <rect x="25%" y="450" height="55" width="50%" />
          <rect x="25%" y="550" height="200" width="50%" />
        </Skeleton>
      </Media>
      <Media lessThan="tablet">
        <Skeleton
          width="100%"
          height={800}
          dataTest="ReferFriendPlaceholder-Mobile"
          title={intl.formatMessage({
            id: 'common.loading',
            defaultMessage: 'Loading',
          })}
        >
          <rect x="0" y="0" height="200" width="100%" />
          <rect x="0" y="250" height="55" width="100%" />
          <rect x="0" y="350" height="300" width="100%" />
        </Skeleton>
      </Media>
      <Skeleton
        width="100%"
        height={300}
        dataTest="ReferFriendPlaceholder2"
        title={intl.formatMessage({
          id: 'common.loading',
          defaultMessage: 'Loading',
        })}
      >
        <rect x="0" y="0" height="300" width="48%" />
        <rect x="470" y="0" height="300" width="48%" />
      </Skeleton>
    </>
  );
};

export default ReferFriendPlaceholder;
